var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "94.187",
        height: "94.187",
        viewBox: "1078.705 575.906 94.187 94.187",
      },
    },
    [
      _c("g", { attrs: { "data-name": "whatsapp-svgrepo-com-6" } }, [
        _c("path", {
          attrs: {
            d: "M1125.814 575.906h-.029c-25.96 0-47.08 21.121-47.08 47.092a46.768 46.768 0 0 0 8.968 27.603l-5.866 17.5 18.1-5.787c7.443 4.928 16.33 7.78 25.907 7.78 25.962 0 47.078-21.126 47.078-47.094 0-25.971-21.116-47.094-47.078-47.094Zm27.4 66.501c-1.132 3.21-5.646 5.869-9.243 6.646-2.464.524-5.674.94-16.495-3.545-13.841-5.73-22.754-19.795-23.445-20.71-.665-.914-5.592-7.448-5.592-14.203 0-6.756 3.432-10.051 4.817-11.464 1.135-1.162 3.017-1.685 4.816-1.685.583 0 1.106.028 1.578.052 1.384.058 2.075.143 2.988 2.327 1.135 2.74 3.903 9.497 4.236 10.188.331.693.665 1.633.193 2.546-.444.942-.83 1.361-1.52 2.162-.695.8-1.36 1.412-2.05 2.27-.637.747-1.358 1.55-.553 2.934.803 1.36 3.57 5.87 7.638 9.495 5.258 4.679 9.52 6.175 11.044 6.812 1.134.472 2.492.358 3.323-.526 1.05-1.136 2.353-3.017 3.68-4.872.94-1.332 2.132-1.496 3.376-1.027 1.275.442 8.003 3.766 9.387 4.459 1.38.693 2.295 1.024 2.626 1.606.332.585.332 3.324-.805 6.535Z",
            fill: "#7fd371",
            "fill-rule": "evenodd",
            "data-name": "Path 345",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M1078.705 622.998a46.768 46.768 0 0 0 8.968 27.603l-5.866 17.5 18.1-5.787c7.443 4.928 16.33 7.78 25.907 7.78 25.962 0 47.078-21.126 47.078-47.094 0-25.971-21.116-47.094-47.078-47.094h-.029m27.428 66.501c-1.131 3.21-5.645 5.869-9.242 6.646-2.464.524-5.674.94-16.495-3.545-13.841-5.73-22.754-19.795-23.445-20.71-.665-.914-5.592-7.448-5.592-14.203 0-6.756 3.432-10.051 4.817-11.464 1.135-1.162 3.017-1.685 4.816-1.685.583 0 1.106.028 1.578.052 1.384.058 2.075.143 2.988 2.327 1.135 2.74 3.903 9.497 4.236 10.188.331.693.665 1.633.193 2.546-.444.942-.83 1.361-1.52 2.162-.695.8-1.36 1.412-2.05 2.27-.637.747-1.358 1.55-.553 2.934.803 1.36 3.57 5.87 7.638 9.495 5.258 4.679 9.52 6.175 11.044 6.812 1.134.472 2.492.358 3.323-.526 1.05-1.136 2.353-3.017 3.68-4.872.94-1.332 2.132-1.496 3.376-1.027 1.275.442 8.003 3.766 9.387 4.459 1.38.693 2.295 1.024 2.626 1.606.332.585.332 3.324-.805 6.535Z",
            fill: "#6dbc61",
            "fill-rule": "evenodd",
            "data-name": "Path 346",
          },
        }),
        _vm._v(" "),
        _c("g", { attrs: { "data-name": "Group 174" } }, [
          _c("path", {
            attrs: {
              d: "M1140.87 578.39c12.008 10.265 19.845 25.955 19.845 39.238 0 7.316-2.384 14.162-6.523 20.042-.055 1.214-.324 2.89-.98 4.737-1.132 3.21-5.645 5.869-9.243 6.646a12.52 12.52 0 0 1-2.303.301c-7.881 4.915-17.65 7.824-28.23 7.824-9.528 0-18.392-2.366-25.818-6.425l-5.81 17.347 18.099-5.786c7.443 4.928 16.33 7.78 25.907 7.78 25.962 0 47.078-21.126 47.078-47.094 0-20.703-13.426-38.313-32.022-44.61Z",
              fill: "#549b45",
              "fill-rule": "evenodd",
              "data-name": "Path 347",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M1142.004 629.809c.316.11.96.395 1.774.77l-31.47-31.47c.109.21.22.448.33.718 1.135 2.739 3.903 9.496 4.236 10.187.331.693.665 1.633.193 2.546-.444.942-.83 1.362-1.52 2.162-.695.8-1.36 1.413-2.05 2.27-.637.747-1.358 1.55-.553 2.935.803 1.36 3.57 5.87 7.638 9.494 5.258 4.68 9.52 6.176 11.044 6.812 1.134.473 2.492.359 3.323-.525 1.05-1.137 2.353-3.017 3.68-4.872.94-1.333 2.132-1.497 3.375-1.027Z",
              fill: "#549b45",
              "fill-rule": "evenodd",
              "data-name": "Path 348",
            },
          }),
        ]),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "m1098.442 610.637-.31.312.339.337c-.012-.216-.029-.432-.029-.649Z",
            fill: "#5caa4f",
            "fill-rule": "evenodd",
            "data-name": "Path 349",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }